import { SafePipe } from './safe.pipe';
import { NgModule } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { PosterPipe } from './poster.pipe';
import { ThumbnailImage } from './thumbnailImage.pipe';
import { FormatDate } from './formatDate.pipe';

@NgModule({
  declarations: [PosterPipe, SafePipe, ThumbnailImage, FormatDate],
  exports: [PosterPipe, SafePipe, ThumbnailImage, FormatDate],
  imports: [CommonModule],
})
export class PipesModule { }
